let _ = require("ES/lib/lodash");
let radio = require("ES/lib/radio");
let Balboa = require("ES/services/Balboa");
let esUtils = require("ES/utils/esUtils");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

// {year: calendars_data}
let calendars_cache = {};

module.exports.init = function () {
  RadioService("Calendar_get", function ({year, ignore_cache, just_re_load_cache, include_other_companies, empire_mode}, callback) {

    if (just_re_load_cache || (calendars_cache[year] && !ignore_cache)) {
      //console.log("Calendar", "cache", calendars_cache);
      callback(null, calendars_cache);
      return;
    }
    Balboa.api("/calendar/index", {
      year,
      month: 1,
      qtymonths: 12,
      include_details: true,
      include_other_companies: include_other_companies,
      empire_mode: empire_mode,
      version: '2.0',
    }, function (data) {
      calendars_cache[year] = data.data;
      callback(null, calendars_cache);
    }, function (data) {
      callback(_.get(data, "message", "mysterious problem"));
    });
  }, function ({year, include_other_companies}) {
    return year;
  });

  radio("save_Event_succeeded").subscribe(function (event) {
    let year = null;
    let Stagetime = _.first(event && event.Stagetime) || {};
    if (_.isDate(Stagetime.starttime)) {
      year = Stagetime.starttime.getFullYear();
    } else {
      year = (new Date()).getFullYear();
    }
    radio("Calendar_get").broadcast({year, ignore_cache: true});
  });

  radio("Event_destroy").subscribe(function (event_id) {
    _.each(calendars_cache, function (calendars_data, year) {
      let detail_ids = [];
      _.each(calendars_data.details, function (detail, detail_id) {
        if (event_id == detail.eid) {
          detail_ids.push(detail_id);
        }
      });
      detail_ids = esUtils.cleanup_ids(detail_ids);
      _.each(calendars_data.calendar, function (months, year) {
        _.each(months, function (days, month) {
          _.each(days, function (day, date) {
            day.detail_ids = _.difference(day.detail_ids, detail_ids);
          });
        });
      });
    });
    radio("Calendar_get").broadcast({just_re_load_cache: true});
  });

  RadioService("AccountingLock_read", function (params, callback) {
    Balboa.api("/accountinglock/read", {}, function (data) {
      callback(null, data.data);
    }, function (data) {
      callback((data && data.message) || "unknown cause");
    });
  });

  RadioService("AccountingLock_toggle", function ({year, month}, callback) {
    Balboa.api("/accountinglock/toggle", {
      year,
      month
    }, function (data) {
      callback(null, data.data);
    }, function (data) {
      callback((data && data.message) || "unknown cause");
    });
  });
};



// WEBPACK FOOTER //
// ./src/services/Calendar.js